/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum IntegrationActivityEventType {
    CONNECTION_CONNECTED = 'connection_connected',
    CONNECTION_UPDATED = 'connection_updated',
    CONNECTION_DISCONNECTED = 'connection_disconnected',
    SYNC_REQUESTED = 'sync_requested',
    SYNC_STARTED = 'sync_started',
    SYNC_APPLIED = 'sync_applied',
    SYNC_SKIPPED = 'sync_skipped',
    SYNC_FAILED = 'sync_failed',
    SYNC_COMPLETED = 'sync_completed',
    SYNC_SUPERSEDED = 'sync_superseded',
    SYNC_RECONCILIATION_APPLIED = 'sync_reconciliation_applied',
    PUBLICATION_CREATED = 'publication_created',
    PUBLICATION_DRAFT_PREPARED = 'publication_draft_prepared',
    PUBLICATION_PUBLISH_ENQUEUED = 'publication_publish_enqueued',
    PUBLICATION_PUBLISHED = 'publication_published',
    PUBLICATION_PUBLISH_FAILED = 'publication_publish_failed',
    PUBLICATION_PAUSE_ENQUEUED = 'publication_pause_enqueued',
    PUBLICATION_PAUSED = 'publication_paused',
    PUBLICATION_PAUSE_FAILED = 'publication_pause_failed',
    PUBLICATION_UNPUBLISH_ENQUEUED = 'publication_unpublish_enqueued',
    PUBLICATION_UNPUBLISHED = 'publication_unpublished',
    PUBLICATION_UNPUBLISH_FAILED = 'publication_unpublish_failed',
}
